
<template>

    <div>
        <iframe id="iFrame" ref="iFrame"></iframe>

        <a-button id="btnPrint" type="primary" @click="printFormatKerja()"><a-icon type="printer" theme="filled" style="font-size: 24px; position: relative; left: -3px;" /></a-button>
    </div>
</template>

<script>

import WorkingFormatApi from "../../../repository/api/WorkingFormatApi";

export default {
    name: "DetailFormatKerjaKoas",

    data() {
        return {
            data: {},
            iFrame: {},
        }
    },

    async mounted() {
        this.getData()

        // // listener is a function, optionally accepting an event and
        // // a function that prints the entire page
        // const addPrintEventListener = function (listener) {
        //
        //     // IE 5.5+ support and HTML5 standard
        //     if ("onbeforeprint" in window) {
        //         window.addEventListener('beforeprint', listener);
        //     }
        //
        //     // Chrome 9+, Firefox 6+, IE 10+, Opera 12.1+, Safari 5.1+
        //     else if (window.matchMedia) {
        //         var mqList = window.matchMedia("print");
        //
        //         mqList.addListener(function (mql) {
        //             if (mql.matches) listener();  // no standard event anyway
        //         });
        //     }
        //
        //         // Your fallback method, only working for JS initiated printing
        //     // (but the easiest case because there is no need to cancel)
        //     else {
        //         (function (oldPrint) {
        //             window.print = function () {
        //                 listener(undefined, oldPrint);
        //             }
        //         })(window.print);
        //     }
        // }
        //
        // const printContentFrameOnly = function (event) {
        //     console.log("SSSS")
        //
        //     if (event) event.preventDefault();  // not going to work
        //     document.getElementById("iFrame").contentWindow.print();
        // }
        //
        // addPrintEventListener(printContentFrameOnly);

    },

    methods: {
        getData() {
            WorkingFormatApi.detail(this.$route.params.id)
                .then((response) => {
                    this.data = response
                    const iframe = this.$refs['iFrame']
                    const iframedoc = iframe.contentDocument || iframe.contentWindow.document;

                    iframedoc.body.innerHTML = this.data.content
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        printFormatKerja() {
            document.getElementById("iFrame").contentWindow.print();
        },
    },
}

</script>

<style lang="scss">

@media all {
    #btnPrint {
        position: fixed;
        right: 30px;
        bottom : 20px;
        border-radius: 1000px;
        width: 50px;
        height: 50px;
    }

    #iFrame {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        border: none;
    }
}

</style>
